<div class="tw-w-full te-bg-red-400 tw-rounded-t-5 tw-p-5 tw-relative tw-pt-8 streak-broken-bg" style="background-image: url('/assets/gamification-intro-bg.png')">
  <div class="tw-w-fit tw-mx-auto tw-mb-5">
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_44685_47231)">
        <rect width="32" height="32" rx="16" fill="#F9E7D7"/>
        <g opacity="0.15">
          <rect width="103" height="102" transform="translate(0 17)" fill="url(#paint0_radial_44685_47231)"/>
        </g>
        <mask id="mask0_44685_47231" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="4" y="4" width="24" height="24">
          <rect x="4" y="4" width="24" height="24" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_44685_47231)">
          <path d="M19.5 15C19.9167 15 20.2708 14.8542 20.5625 14.5625C20.8542 14.2708 21 13.9167 21 13.5C21 13.0833 20.8542 12.7292 20.5625 12.4375C20.2708 12.1458 19.9167 12 19.5 12C19.0833 12 18.7292 12.1458 18.4375 12.4375C18.1458 12.7292 18 13.0833 18 13.5C18 13.9167 18.1458 14.2708 18.4375 14.5625C18.7292 14.8542 19.0833 15 19.5 15ZM12.5 15C12.9167 15 13.2708 14.8542 13.5625 14.5625C13.8542 14.2708 14 13.9167 14 13.5C14 13.0833 13.8542 12.7292 13.5625 12.4375C13.2708 12.1458 12.9167 12 12.5 12C12.0833 12 11.7292 12.1458 11.4375 12.4375C11.1458 12.7292 11 13.0833 11 13.5C11 13.9167 11.1458 14.2708 11.4375 14.5625C11.7292 14.8542 12.0833 15 12.5 15ZM16 17.5C14.8667 17.5 13.8375 17.8208 12.9125 18.4625C11.9875 19.1042 11.3167 19.95 10.9 21H12.55C12.9167 20.3833 13.4042 19.8958 14.0125 19.5375C14.6208 19.1792 15.2833 19 16 19C16.7167 19 17.3792 19.1792 17.9875 19.5375C18.5958 19.8958 19.0833 20.3833 19.45 21H21.1C20.6833 19.95 20.0125 19.1042 19.0875 18.4625C18.1625 17.8208 17.1333 17.5 16 17.5ZM16 26C14.6167 26 13.3167 25.7375 12.1 25.2125C10.8833 24.6875 9.825 23.975 8.925 23.075C8.025 22.175 7.3125 21.1167 6.7875 19.9C6.2625 18.6833 6 17.3833 6 16C6 14.6167 6.2625 13.3167 6.7875 12.1C7.3125 10.8833 8.025 9.825 8.925 8.925C9.825 8.025 10.8833 7.3125 12.1 6.7875C13.3167 6.2625 14.6167 6 16 6C17.3833 6 18.6833 6.2625 19.9 6.7875C21.1167 7.3125 22.175 8.025 23.075 8.925C23.975 9.825 24.6875 10.8833 25.2125 12.1C25.7375 13.3167 26 14.6167 26 16C26 17.3833 25.7375 18.6833 25.2125 19.9C24.6875 21.1167 23.975 22.175 23.075 23.075C22.175 23.975 21.1167 24.6875 19.9 25.2125C18.6833 25.7375 17.3833 26 16 26ZM16 24C18.2333 24 20.125 23.225 21.675 21.675C23.225 20.125 24 18.2333 24 16C24 13.7667 23.225 11.875 21.675 10.325C20.125 8.775 18.2333 8 16 8C13.7667 8 11.875 8.775 10.325 10.325C8.775 11.875 8 13.7667 8 16C8 18.2333 8.775 20.125 10.325 21.675C11.875 23.225 13.7667 24 16 24Z" fill="#BF501F"/>
        </g>
      </g>
      <defs>
        <radialGradient id="paint0_radial_44685_47231" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(51.5 51) rotate(90) scale(51 51.5)">
          <stop stop-color="#39FF94"/>
          <stop offset="1" stop-color="#CCFDFF" stop-opacity="0"/>
        </radialGradient>
        <clipPath id="clip0_44685_47231">
          <rect width="32" height="32" rx="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  </div>
  <div class="tw-absolute tw-top-4 tw-right-4" (click)="closeBottomSheet()">
    <img src="/assets/icons/close.svg" alt="close-icon">
  </div>
  <div class="tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-font-lexend tw-mb-5">
    <p class="tw-text-700 tw-leading-none tw-mb-4 tw-font-bold -tw-tracking-[1px]" i18n="@@challengeBroken">Oops! Challenge Broken</p>
    <p class="tw-text-center tw-text-gray-500 tw-leading-5 tw-font-normal tw-text-300" i18n="@@youMissedDayChallenge">You missed a day in your <br/> 7 day #SkinStart Challenge.</p>
  </div>
  <div class="tw-w-full tw-p-4 tw-rounded-3 tw-border tw-border-gray-300 tw-mb-5 tw-flex tw-flex-col tw-items-center tw-gap-3">
    <div class="tw-w-fit tw-flex tw-justify-center tw-gap-6 tw-items-center tw-relative">
      @for (item of [1,2,3,4,5,6,7]; track item; let i = $index) {
        <div [ngClass]="{'tw-bg-teal-500': i === 0, 'tw-bg-[#D15036]': i === 1, 'tw-bg-gray-300': i > 1}" class="tw-w-[18px] tw-h-[18px] tw-rounded-full tw-bg-teal-500 tw-flex tw-justify-center tw-items-center tw-relative tw-z-[1]">
          @if (i === 1) {
            <svg
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              class="tw-w-2.5 tw-h-2.5 tw-text-white"
              >
              <path
                d="M6 6 L18 18"
                stroke="currentColor"
                stroke-width="3.5"
                stroke-linecap="round"
                />
              <path
                d="M18 6 L6 18"
                stroke="currentColor"
                stroke-width="3.5"
                stroke-linecap="round"
                />
            </svg>
          }
          @if (i > 1) {
            <app-lock-icon></app-lock-icon>
          }
        </div>
      }
      <div class="tw-w-full tw-absolute tw-left-1/2 -tw-translate-x-1/2 tw-top-1/2 -tw-translate-y-1/2 tw-h-0.5 tw-flex tw-items-center tw-z-0">
        <div class="tw-w-[25%] tw-bg-teal-400 tw-h-full"></div>
        <div class="tw-w-full tw-bg-gray-200 tw-h-full"></div>
      </div>
    </div>
    <p class="tw-text-200 tw-font-body" i18n="@@youWereDoingGreat">You were doing great! Restart your challenge.</p>
  </div>
  <div class="tw-w-full tw-bg-white tw-p-4 tw-rounded-3 tw-mb-5">
    <p class="tw-text-gray-600 tw-font-bold tw-font-body tw-text-200 tw-mb-3" i18n="@@remember">Remember</p>
    <div class="tw-w-full tw-flex tw-flex-col tw-gap-3 tw-bg-white">
      <div class="tw-w-full tw-flex tw-items-center tw-justify-start tw-gap-3 tw-rounded-2.5">
        <div class="tw-w-6 tw-aspect-square tw-rounded-full tw-bg-teal-400">
          <img src="/assets/icons/paint.svg" alt="paint-icon">
        </div>
        <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-between">
          <p class="tw-font-lexend tw-text-200 tw-text-gray-500" i18n="@@applyProductsDaily">Apply your products daily</p>
        </div>
      </div>
      <div class="tw-w-full tw-flex tw-items-center tw-justify-start tw-gap-3 tw-rounded-2.5">
        <div class="tw-w-6 tw-aspect-square tw-rounded-full tw-bg-teal-400">
          <img src="/assets/icons/usage.svg" alt="usage-icon">
        </div>
        <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-between">
          <p class="tw-font-lexend tw-text-200 tw-text-gray-500" i18n="@@tickOnCureskinApp">Tick on Cure app after use</p>
        </div>
      </div>
      <div class="tw-w-full tw-flex tw-items-center tw-justify-start tw-gap-3 tw-rounded-2.5">
        <div class="tw-w-6 tw-aspect-square tw-rounded-full tw-bg-teal-400">
          <img src="/assets/icons/reward.svg" alt="reward-icon">
        </div>
        <div class="tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-between">
          <p class="tw-font-lexend tw-text-200 tw-text-gray-500" i18n="@@getScratchCardDay7">Get your scratch card on day 7</p>
        </div>
      </div>
    </div>
  </div>
  <span class="tw-border tw-w-full tw-py-3 tw-flex tw-justify-center tw-items-center tw-font-bold tw-font-lexend tw-text-500 tw-rounded-3 tw-bg-teal-600 tw-text-white tw-mb-5" i18n="@@restartMy7DayChallenge" (click)="closeBottomSheet()">Restart My 7-Day Challenge</span>
</div>
